import { render, staticRenderFns } from "./TemperatureUnitsSelector.vue?vue&type=template&id=5d8260e0&scoped=true&"
import script from "./TemperatureUnitsSelector.vue?vue&type=script&lang=js&"
export * from "./TemperatureUnitsSelector.vue?vue&type=script&lang=js&"
import style0 from "./TemperatureUnitsSelector.vue?vue&type=style&index=0&id=5d8260e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8260e0",
  null
  
)

export default component.exports